import { GeoShapeType } from "../../geography";
import { BoundedCollection, Cartesian3 } from "../../geometry";
import { Polygon } from "../../geometry/shapes/geometry.polygon";
import { Polyline } from "../../geometry/shapes/geometry.polyline";
import { Line } from "../../geometry/shapes/geometry.line";
import { PolylineSimplifier } from "../../geometry/geometry.simplify";
import { Observable } from "../../events";
export class ShapeCollectionEventArgs {
    constructor(lod, IShapes) {
        this.lod = lod;
        this.IShapes = IShapes;
    }
}
export class ShapeCollection {
    constructor(metrics, simplifier) {
        this._metrics = metrics;
        this._shapes = new Array(metrics.maxLOD - metrics.minLOD + 1);
        this._simplifier = simplifier ?? new PolylineSimplifier(ShapeCollection.DefaultSimplifyTolerance, ShapeCollection.DefaultSimplifyHighQuality);
    }
    get metrics() {
        return this._metrics;
    }
    get addedObservable() {
        if (this._addedObservable === undefined) {
            this._addedObservable = new Observable();
        }
        return this._addedObservable;
    }
    get removedObservable() {
        if (this._removedObservable === undefined) {
            this._removedObservable = new Observable();
        }
        return this._removedObservable;
    }
    get(lod) {
        if (lod < this._metrics.minLOD || lod > this._metrics.maxLOD) {
            return null;
        }
        return this._shapes[lod - this._metrics.minLOD];
    }
    trySet(lod, ...shapes) {
        let collection = this.get(lod);
        const views = shapes.map((s) => this._buildShape(s, lod, this.metrics)).filter((v) => v !== null);
        if (views.length === 0) {
            return false;
        }
        if (!collection) {
            collection = new BoundedCollection();
            this._shapes[lod - this._metrics.minLOD] = collection;
        }
        collection.push(...views);
        if (this._addedObservable !== undefined && this._addedObservable.hasObservers()) {
            this._addedObservable.notifyObservers(new ShapeCollectionEventArgs(lod, views), -1, this, this);
        }
        return true;
    }
    _buildShape(shape, lod, metrics) {
        switch (shape.type) {
            case GeoShapeType.Polygon: {
                return this._buildPolygon(shape, lod, metrics);
            }
            case GeoShapeType.Line: {
                return this._buildLine(shape, lod, metrics);
            }
            case GeoShapeType.Polyline: {
                return this._buildPolyline(shape, lod, metrics);
            }
            default: {
                return null;
            }
        }
    }
    _buildPolygon(shape, lod, metrics) {
        const points = this._transform(shape.points, lod, metrics);
        return Polygon.FromPoints(points);
    }
    _buildLine(shape, lod, metrics) {
        const a = Cartesian3.Zero();
        const b = Cartesian3.Zero();
        metrics.getLatLonToPointXYToRef(shape.start.lat, shape.start.lon, lod, a);
        metrics.getLatLonToPointXYToRef(shape.end.lat, shape.end.lon, lod, b);
        return this._filter(a, b) ? new Line(a, b) : null;
    }
    _buildPolyline(shape, lod, metrics) {
        const points = this._transform(shape.points, lod, metrics);
        return this._filter(...points) ? Polyline.FromPoints(points) : null;
    }
    _transform(geo, lod, metrics) {
        const result = geo.map((p) => {
            const ref = Cartesian3.Zero();
            metrics.getLatLonToPointXYToRef(p.lat, p.lon, lod, ref);
            return ref;
        });
        if (result.length > 2 && this._simplifier) {
            return this._simplifier.simplify(result);
        }
        return result;
    }
    _filter(...args) {
        if (args.length < 2)
            return true;
        const p1 = args[0];
        const p2 = args[1];
        return Cartesian3.Equals(p1, p2, ShapeCollection.Epsilon) == false;
    }
}
ShapeCollection.DefaultSimplifyTolerance = 2;
ShapeCollection.DefaultSimplifyHighQuality = false;
ShapeCollection.Epsilon = 1;
//# sourceMappingURL=tiles.geography.collection.js.map